import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import api from '../../services/api';
import Checkbox from '@mui/material/Checkbox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import {
  TextField,
  FormGroup,
  Container,
  Grid,
  Autocomplete,
} from '@mui/material';
import {
  LocalizationProvider,
  DatePicker,
  TimePicker,
} from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/pt';
import DateFnsUtils from '@date-io/date-fns';
import * as Yup from 'yup';
import Progress from '../../components/Progress';
import { useDispatch, useSelector } from 'react-redux';
import { setDisable } from '../../redux/disable';
import { setLoading } from '../../redux/loading';
import deLocale from 'date-fns/locale/pt-BR';
import { useStyles } from '../../components/Styles';
import Success from '../../components/Snack/Success';
import Error from '../../components/Snack/Error';
import GroupButton from '../../components/Buttons/ButtonGroup';
import TextFieldCustom from '../../components/Inputs/TextField/TextField';

function EquipmentSpent() {
  const [locale, setLocale] = React.useState('pt');
  const location = useLocation();
  const time = new Date();
  const outraData = new Date();
  outraData.setDate(time.getDate() + 120); // Adiciona 120 dias

  // Dia
  const [selectedStartTime, handleStartTimeChange] = useState(new Date());
  const [selectedEndTime, handleEndTimeChange] = useState(new Date());
  // Hora
  const [selectedStartHour, handleStartHourChange] = useState(new Date());
  const [selectedEndHour, handleEndHourChange] = useState(new Date());

  const [openProgress, setOpenProgress] = useState(false);
  const classes = useStyles();
  const [equipments, setEquipments] = useState([]);
  const [payBill, setPayBill] = useState([]);

  const [selectedEquipments, handleEquipment] = useState(null);
  const [selectedPayBill, handlePayBill] = useState(null);

  const error = Error();
  const success = Success();
  const dispatch = useDispatch();

  const [ponds, setPonds] = useState([]);
  const [selectedPonds, handlePonds] = useState([]);

  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;

  const history = useHistory();
  let { id } = useParams();
  const disable = useSelector((state) => state.disable.disable);

  useEffect(() => {
    if (location.state !== undefined) {
      if (location.state.customData) {
        setData(location.state.customData);
      } else if (location.state.data) {
        setData(location.state.data);
      }
    }
  }, [location]);

  function setData(data) {
    id = location.state.id;
    formik.setValues(data);
    formik.setValues(data);

    handlePonds(data.ponds);
    handleEquipment(data.equipment);
    handlePayBill(data.payBill);
    handleStartHourChange(new Date(data.startTime));
    handleEndHourChange(new Date(data.endTime));

    handleStartTimeChange(new Date(data.startTime));
    handleStartHourChange(new Date(data.startTime));
    handleEndTimeChange(new Date(data.endTime));
    handleEndHourChange(new Date(data.endTime));
  }

  const formik = useFormik({
    initialValues: {
      ponds: [],
      equipment: null,
      startTime: '',
      endTime: '',
      estimatedConsumption: '',
      payBill: null,
    },
    validationSchema: Yup.object({
      estimatedConsumption: Yup.number()
        .required('Campo Obrigatório')
        .min(0, 'Precisa ser acima de 0')
        .max(
          999999999,
          'Valor máximo ultrapassado. Diminua a quantidade de energia'
        )
        .integer('O valor deve ser um número inteiro'),
    }),
    onSubmit: (values) => {
      // dispatch(setDisable(true));
      dispatch(setLoading(true));

      // Start Date and Time
      selectedStartTime.setHours(selectedStartHour.getHours());
      selectedStartTime.setMinutes(selectedStartHour.getMinutes());
      // End Date and Time
      selectedEndTime.setHours(selectedEndHour.getHours());
      selectedEndTime.setMinutes(selectedEndHour.getMinutes());

      values.startTime = selectedStartTime.toUTCString();
      values.endTime = selectedEndTime.toUTCString();
      values.equipment = selectedEquipments.id;
      values.payBill = selectedPayBill.id;
      values.ponds = selectedPonds;
      values.pond = null;

      request(values);
    },
  });

  useEffect(() => {
    // carrega os dados no seu devido campo caso tenha id, do contrário,
    // carrega o formulário vazio para cadastrar um novo
    async function load() {
      setOpenProgress(true);

      const pond_ = await api.get('/ponds');
      setPonds(pond_.data);

      const equipments_ = await api.get('/equipments');
      setEquipments(equipments_.data);

      const payBills_ = await api.get('/bills');
      setPayBill(payBills_.data);

      setOpenProgress(false);
    }
    load();
  }, []);

  async function request(data) {
    // envia os dados para api salvar no banco
    try {
      id
        ? await api.put(`/equipment-spents/${id}`, { ...data })
        : await api.post('/equipment-spents', { ...data });
      success();
      history.push('/equipment-spents');
    } catch (err) {
      error();
    }
    dispatch(setDisable(false));
    dispatch(setLoading(false));
  }

  // Criação dos campos e validação para o formulário

  return (
    <Container>
      {openProgress ? <Progress /> : null}{' '}
      {/** Carregamento circular para o carregamento dos dados */}
      <form onSubmit={formik.handleSubmit}>
        <div className={classes.root}>
          <h2 className="title">Consumo estimado</h2>
          <FormGroup>
            <Autocomplete
              noOptionsText="Sem opções"
              name="equipment"
              options={equipments}
              value={selectedEquipments}
              getOptionLabel={(options) => options.name}
              onChange={(p, v) => {
                handleEquipment(v);
              }}
              onBlur={formik.handleBlur}
              renderInput={(params) => (
                <TextField {...params} label="Equipamento" variant="outlined" />
              )}
            />
          </FormGroup>
          <FormGroup>
            <LocalizationProvider
              adapterLocale={deLocale}
              dateAdapter={DateFnsUtils}
            >
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <DatePicker
                    InputLabelProps={{ style: { pointerEvents: 'auto' } }}
                    fullWidth
                    variant="inline"
                    inputVariant="outlined"
                    invalidDateMessage="Data Inválida"
                    label={<div>Data de início</div>}
                    format="dd/MM/yyyy"
                    value={selectedStartTime}
                    onChange={(date) => {
                      handleStartTimeChange(date);
                      formik.setFieldValue('startTime', date);
                    }}
                    // inputFormat="DD/MM/YYYY"
                    renderInput={(params) => <TextField {...params} />}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TimePicker
                    InputLabelProps={{ style: { pointerEvents: 'auto' } }}
                    fullWidth
                    variant="inline"
                    inputVariant="outlined"
                    invalidDateMessage="Hora inválida"
                    label={<div>Hora inicial</div>}
                    format="HH:mm"
                    value={selectedStartHour}
                    onChange={(date) => handleStartHourChange(date)}
                    // inputFormat="HH:mm"
                    renderInput={(params) => <TextField {...params} />}
                  />
                </Grid>
              </Grid>
            </LocalizationProvider>
          </FormGroup>
          <FormGroup>
            <LocalizationProvider
              adapterLocale={deLocale}
              dateAdapter={DateFnsUtils}
            >
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <DatePicker
                    InputLabelProps={{ style: { pointerEvents: 'auto' } }}
                    fullWidth
                    variant="inline"
                    inputVariant="outlined"
                    invalidDateMessage="Data Inválida"
                    label={<div>Data do fim</div>}
                    format="dd/MM/yyyy"
                    value={selectedEndTime}
                    onChange={(date) => {
                      handleEndTimeChange(date);
                      formik.setFieldValue('endTime', date);
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TimePicker
                    InputLabelProps={{ style: { pointerEvents: 'auto' } }}
                    fullWidth
                    variant="inline"
                    inputVariant="outlined"
                    invalidDateMessage="Hora inválida"
                    label={<div>Hora final</div>}
                    format="HH:mm"
                    value={selectedEndHour}
                    onChange={(date) => handleEndHourChange(date)}
                  />
                </Grid>
              </Grid>
            </LocalizationProvider>
          </FormGroup>
          <FormGroup>
            <TextFieldCustom
              id="estimatedConsumption"
              label="Consumo Estimado"
              type="number"
              formik={formik}
              value={formik.values.estimatedConsumption}
              errorAndHelper="Consumo Estimado"
              onChange={(e) => {
                formik.setFieldValue(
                  'estimatedConsumption',
                  parseFloat(e.target.value)
                );
              }}
            />
          </FormGroup>
          <FormGroup>
            <Autocomplete
              multiple
              id="viveiros"
              options={ponds}
              disableCloseOnSelect
              getOptionLabel={(option) => option.description}
              value={selectedPonds}
              onChange={(e, v) => {
                handlePonds(v);
              }}
              renderOption={(props, option, { selected }) => (
                <li {...props}>
                  <Checkbox
                    icon={icon}
                    color="primary"
                    checkedIcon={checkedIcon}
                    style={{ marginRight: 8 }}
                    checked={selected}
                  />
                  {option.description}
                </li>
              )}
              renderInput={(params) => (
                <TextField {...params} variant="outlined" label="Viveiros" />
              )}
            />
          </FormGroup>
          <FormGroup>
            <Autocomplete
              noOptionsText="Sem opções"
              name="payBill"
              options={payBill}
              value={selectedPayBill}
              getOptionLabel={(options) => options.description}
              onChange={(p, v) => {
                handlePayBill(v);
              }}
              onBlur={formik.handleBlur}
              renderInput={(params) => (
                <TextField {...params} label="PayBill" variant="outlined" />
              )}
            />
          </FormGroup>
        </div>

        <GroupButton
          deleteRoute="/equipment-spents/"
          routeDelete="/equipment-spents"
          returnRoute="/equipment-spents"
          id={id}
          disable={disable}
          message="A exclusão dessa população pode levar a exclusão de objetos que dependam dela. Tem certeza que deseja excluir?"
        />
      </form>
    </Container>
  );
}

export default EquipmentSpent;
